export default {
  roles: 'الأدوار',
  role: 'الدور',
  add: 'إضافة دور',
  details: 'تفاصيل الدور',
  name: 'الاسم',
  permissions: 'الصلاحيات'
}
